module.exports = __webpack_public_path__ + "static/mmxxml-eca717c3710bdbfc6af9d4f6eddc0b2e.jpg";